module.exports = __webpack_public_path__ + "img/leaf-L.2f48da1a.svg";